import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter as Router} from "react-router-dom";
import App from './App';
import * as serviceWorker from './serviceWorker';
import { MuiThemeProvider } from '@material-ui/core';
import anyplayTheme from './anyplayTheme';
import {ProfileState} from "./context/profile/ProfileState";
import './index.css';
import './plugins/i18n';

ReactDOM.render(
  <ProfileState>
    <Router>
      <MuiThemeProvider theme = { anyplayTheme }>
          <App />
      </MuiThemeProvider>
    </Router>
  </ProfileState>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
